module.exports = "/_next/static/images/perks-rhetlink-d9e85756a8519f142c222bf07e49af5c.png";